<div class="modal--replaement">
  <h1 class="modal__header">Replacement Policy</h1>
  <form class="coverPathForm" id="replaceForm" [formGroup]="replaceForm">
    <p class="label-basic__text">
      Is the inforce life insurance or annuity contract being replaced a term or whole life policy?
    </p>
    <div>
      <select-basic
        [propertyName]="'policyType'"
        [placeholder]="'select type of existing policy'"
        [optionValues]="selectOptions"
        formControlName="policyType"
        (valueChanged)="getSelectedPolicyOption()"
        [noLabel]="true"
        [formGroupComponent]="true"
      ></select-basic>
    </div>
    <div *ngIf="showSecondQuesion" class="second_question">
      <p class="label-basic__text">
        Is the inforce life insurance or annuity contract being replaced a {{ internalPolicies }} policy?
      </p>
      <div class="contentPadding">
        <radio-group
          [propertyName]="'YesNoProperty'"
          [valueOptions]="YesNoOptions"
          formControlName="YesNoProperty"
          (valueChanged)="setValue()"
          [formGroupComponent]="true"
        ></radio-group>
      </div>
    </div>
  </form>
  <div class="modal__actions modal__actions--inline">
    <button class="button button--blue button--primary modal__button" (click)="goBack()">Go Back</button>
    <button
      *ngIf="isAdvisor"
      class="button button--blue button--secondary button--no-border modal__button"
      (click)="exit()"
    >
      Exit Now
    </button>
  </div>
</div>
